module.exports = __webpack_public_path__ + "img/b2b04.aaeb82f7.png";